import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import i18next from "i18next";
import { Product } from "./Interfaces";
import { ProductSimpleTable } from "./ProductSimpleTable";

export interface ExcelProduct extends Omit<Product,  'category'> {
	category?: Product['category'];
	categoryName: string;

	errors?: string[];
}



interface ProductUploadConfirmDialogProps {
	open: boolean;
	onClose: () => void;
	uploadError: string;
	excelProducts: ExcelProduct[];

	setOpenPreviewDialog: (open: boolean) => void;

	handleUploadConfirm: () => void;

}

export const ProductUploadConfirmDialog = (props: ProductUploadConfirmDialogProps) => {
	const { open, onClose, uploadError, excelProducts, setOpenPreviewDialog, handleUploadConfirm } = props;

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="lg"
			fullWidth
		>
			<DialogTitle>{i18next.t('common.import_confirm')}</DialogTitle>
			<DialogContent>
				{uploadError && (
					<Typography color="error" sx={{ mb: 2 }}>
						{uploadError}
					</Typography>
				)}
				<ProductSimpleTable products={excelProducts} startRowIndex={2}/>

			</DialogContent>
			<DialogActions>
				<Button onClick={() => setOpenPreviewDialog(false)}>
					{i18next.t('common.cancel')}
				</Button>
				<Button disabled={!!uploadError?.length} onClick={handleUploadConfirm} variant="contained" color="primary">
					{i18next.t('common.import')}
				</Button>
			</DialogActions>
		</Dialog>)
}